import { render, staticRenderFns } from "./UpdatingLicence.vue?vue&type=template&id=45f08e6d&"
import script from "./UpdatingLicence.vue?vue&type=script&lang=js&"
export * from "./UpdatingLicence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports